import React from 'react';
import Button from '../Button/Button';
import Text from '../Text/Text';
import './InfoPage.css';

const InfoHeroes = (props) => {

    return (
        <div>
            <img src={props.src} className='bigBg' alt=' ' />
            <Text className='HeroesText' value={props.text} />
            <img src={props.nameSrc} className='nameHero' alt=' ' />
            <Button className='Start' onClick={() => props.onClick('startNewSankarit')} value={props.textGame.Continue[props.lang]} hidden={props.hiddenContinue}/>

            <Button className='GamePrev' onClick={() => props.onClick('prev','infoHeroes')} hidden={props.hiddenPrev} />
            <Button className='ShowNext' onClick={() => props.onClick('ShowNextHistory')} hidden={!props.hiddenContinue} />                 
        </div>
    );
    };

export default InfoHeroes;
